import styled, { css } from "styled-components"

const Tag = styled.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: auto;
  height: 20px;
  padding: 0 5px;
  color: white;
  text-align: center;
  line-height: 18px;
  font-size: 11px;
  font-weight: 500;
  border-radius: 8px;
  border: 1px solid ${({ color }) => color};
  background: ${({ theme, color }) => color || theme.colors.white};

  ${({ theme, outline }) =>
    outline &&
    css`
      border: 1px solid ${theme.colors.mediumBlue};
      color: ${theme.colors.mediumBlue};
    `}
`

export default Tag
